export default __webpack_public_path__ + "static/media/logo-meso-circle-bw.7589140d.png";